import React from 'react';
import '../assets/avatar.scss';

interface IArgs {
    name: string;
}

const Avatar = ({ name }: IArgs) => {
    const [initial, surname] = name.split(' ');
    // eslint-disable-next-line no-magic-numbers
    return (
        <div className={'avatar'} style={{ backgroundColor: '#1b1b1b' }}>
            {initial && surname
                ? `${initial[0]?.toLocaleUpperCase()}${surname[0]?.toLocaleUpperCase()}`
                : ''}
        </div>
    );
};

export default Avatar;
